/* src/app/modules_v2/booking/locations/components/sections/location-availability-section/availability-rule-dialog.component.css */
.availability-dialog {
  width: 100%;
  max-width: 600px;
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  margin: -24px -24px 0 -24px;
}
.dialog-header h2 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.dialog-header h2 mat-icon {
  color: #666;
}
.close-button {
  margin-right: -12px;
}
mat-dialog-content,
.mat-mdc-dialog-content {
  padding: 24px !important;
  max-height: 70vh;
  overflow-y: auto;
}
.rule-form {
  width: 100%;
}
.info-box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  background: #f9ffe0;
  border-left: 3px solid var(--cf-brand-dark);
  border-radius: 4px;
}
.info-box mat-icon {
  color: var(--cf-brand-dark);
}
.info-box span {
  font-weight: 500;
  color: var(--cf-brand-dark);
}
.w-100 {
  width: 100%;
}
mat-form-field {
  width: 100%;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px 15px -10px;
}
.col-md-6,
.col-md-12 {
  padding: 0 10px;
}
.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
.col-md-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
.mb-3 {
  margin-bottom: 20px;
}
.section-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  padding: 16px 24px !important;
  margin: 0 -24px -24px -24px;
  border-top: 1px solid #e0e0e0;
  gap: 10px;
}
@media (max-width: 768px) {
  .availability-dialog {
    max-width: 100%;
  }
  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .dialog-header {
    padding: 16px 20px;
  }
  mat-dialog-content,
  .mat-mdc-dialog-content {
    padding: 20px !important;
  }
  mat-dialog-actions,
  .mat-mdc-dialog-actions {
    flex-direction: column-reverse;
  }
  mat-dialog-actions app-button,
  .mat-mdc-dialog-actions app-button {
    width: 100%;
  }
}
/*# sourceMappingURL=availability-rule-dialog.component.css.map */
